export default {"src":"/_next/static/media/microsoft.616a835a.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};